import { useState } from 'preact/hooks'
import { SearchspringProduct } from 'libs/searchspring/fetchers/product'
import { useSearchspringFetcher } from 'libs/searchspring/fetchers/provider'
import { normaliseResults } from 'libs/searchspring/helpers/normalisers'

export function useSwatches(initialResult) {
  const [currentResult, setCurrentResult] = useState(initialResult)

  const { isLoading, refine } = useSearchspringFetcher(new SearchspringProduct(), {
    runOnMount: false,
    onFetch: handleFetch
  })

  async function handleFetch(data) {
    if (!isLoading && data.results.length > 0) {
      const result = await normaliseResults(data.results)
      setCurrentResult(result[0])
      return result
    }
    return {}
  }

  const updateSwatch = (handle) => {
    refine('handle', handle)
  }

  return { currentResult, isLoading, updateSwatch }
}
